import type { DateRange, MetricChartPoint } from '../types';
import { eachDayInRange } from './ranges';

export const toChartSeries = <T extends { date: string }>(
  rows: T[],
  range: DateRange,
  selector: (row: T) => number | null
): MetricChartPoint[] => {
  const byDate = new Map<string, T>();
  rows.forEach((row) => {
    byDate.set(row.date, row);
  });

  return eachDayInRange(range).map((date) => {
    const row = byDate.get(date);
    if (!row) {
      return { date, value: null };
    }
    const value = selector(row);
    return { date, value: value ?? null };
  });
};
